import type { ReactNode } from "react";
import { Box } from "@hightouch/htui";

import {
  MEDIA_DETAIL_CONTAINER,
  MEDIA_DETAIL_SPLIT_QUERY,
} from "src/components/media-detail/constants";

/**
 * Places `MediaDetailMedia` and `MediaDetailDetails` in a row when this
 * element is at least 700px wide, and in a column otherwise. Media children
 * should size themselves with `maxW="100%"` and `maxH="100%"`.
 */
type Props = {
  children: ReactNode;
};

export function MediaDetailLayout({ children }: Props) {
  return (
    <Box
      w="100%"
      h="100%"
      minH={0}
      // `sx` because `containerType` has no Chakra style prop.
      sx={{
        containerType: "inline-size",
        containerName: MEDIA_DETAIL_CONTAINER,
      }}
    >
      <Box
        display="flex"
        flexDirection="column"
        alignItems="stretch"
        w="100%"
        h="100%"
        minH={0}
        gap={6}
        sx={{
          overflowY: "auto",
          [MEDIA_DETAIL_SPLIT_QUERY]: {
            flexDirection: "row",
            gap: 0,
            overflow: "hidden",
          },
        }}
      >
        {children}
      </Box>
    </Box>
  );
}
